import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally

class ContractGroupV2Deposit extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.state = {
      depositEnabled: props.form.depositEnabled || false,
      depositAmount: props.form.depositAmount || "",
      depositTaxAmount: props.form.depositTaxAmount
        ? parseFloat(props.form.depositTaxAmount).toFixed(2)
        : "",
    }
    this.next = this.next.bind(this)
  }

  fetchData() {
    return this.state
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:deposit_complete")
    this.props.update(this.state)
  }

  next() {
    this.props.route.goNext()
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={this.props.route.hasNext}
        hasPrevious={this.props.route.hasPrevious}
        goNext={this.next}
        goPrevious={this.props.route.goPrevious}
        saving={this.props.saving}
      >
        <div className="form-group">
          <label htmlFor="allow_direct_payment">Security Deposit</label>
          <div className="flex space-x-2">
            <input
              id="deposit"
              name="depositEnabled"
              type="checkbox"
              onChange={(e) =>
                this.setState({
                  depositEnabled: e.target.checked,
                  depositAmount: 0,
                  depositTaxAmount: 0,
                })
              }
              checked={this.state.depositEnabled}
            />
            <p
              className="cursor-pointer"
              onClick={() =>
                this.setState({ depositEnabled: !this.state.depositEnabled })
              }
            >
              Require Security Deposit
            </p>
          </div>
          <p className="text-muted">
            Security Deposit is a one time charge not billed with installments,
            it will be charged immediately when the contract is signed. It can
            be refunded at any point of the reservation.
          </p>
        </div>
        {this.state.depositEnabled && (
          <div className="form-group flex space-x-4">
            <FormGroup
              className="flex-1"
              inputType="currency"
              name="depositAmount"
              label="Security Deposit Amount"
              value={this.state.depositAmount}
              onChange={this.handleInputChange}
              validation={
                this.state.deposit &&
                this.validator.message(
                  "depositAmount",
                  this.state.depositAmount,
                  "required"
                )
              }
            />
            <FormGroup
              className="flex-1"
              inputType="percentage"
              name="depositTaxAmount"
              label="Tax"
              value={this.state.depositTaxAmount}
              onChange={this.handleInputChange}
              validation={
                this.state.deposit &&
                this.validator.message(
                  "depositTaxAmount",
                  this.state.depositTaxAmount,
                  "required"
                )
              }
            />
          </div>
        )}
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2Deposit.propTypes = {
  form: PropTypes.shape({
    depositEnabled: PropTypes.bool,
    depositAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    depositTaxAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  saving: PropTypes.bool,
}

export default ContractGroupV2Deposit
